import { AlphaIBoxOutlineIcon } from './AlphaIBoxOutlineIcon';

/**
 * author: Contributors
 * id E7CF351D-BC47-44AC-BA3E-D61F99D11026
 * name alpha-i-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-i-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterIBoxOutlineIcon = AlphaIBoxOutlineIcon;
export default LetterIBoxOutlineIcon